module.exports = __webpack_public_path__ + "img/t1.4549d30a.jpg";